import { useEffect, useState } from "react";
import api, { apiErr } from "@/lib/api";
import { PageHeader, Loader } from "@/components/ui-kit";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Save, RotateCcw, Link2 } from "lucide-react";
import { toast } from "sonner";

const GROUPS = [
  { title: "Ventes & encaissements", keys: ["clients", "ventes", "tva_collectee"] },
  { title: "Achats, charges & fournisseurs", keys: ["achats", "charges", "fournisseurs"] },
  { title: "Impôts & taxes", keys: ["impots_charge", "etat_impots"] },
  { title: "Salaires", keys: ["salaires_brut", "cnss", "personnel"] },
  { title: "Stock", keys: ["stock"] },
  { title: "Trésorerie", keys: ["banque", "mobile_money", "caisse"] },
];

export default function AccountingMapping() {
  const [data, setData] = useState(null);
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);

  const load = () => api.get("/accounting/mapping").then((r) => { setData(r.data); setForm({ ...r.data.mapping }); });
  useEffect(() => { load(); }, []);

  const save = async () => {
    setSaving(true);
    try { await api.put("/accounting/mapping", { mapping: form }); toast.success("Mapping enregistré"); load(); }
    catch (e) { toast.error(apiErr(e)); } finally { setSaving(false); }
  };
  const resetDefaults = () => { if (data) setForm({ ...data.defaults }); };

  if (!data) return <Loader />;
  const labels = data.labels || {};
  const defaults = data.defaults || {};

  return (
    <div>
      <PageHeader title="Mapping comptable" subtitle="Reliez chaque opération (ventes, achats, salaires, taxes…) à un compte SYSCOHADA pour les écritures automatiques">
        <Button variant="outline" onClick={resetDefaults} data-testid="mapping-reset" className="mr-2"><RotateCcw className="h-4 w-4 mr-1.5" />Valeurs par défaut</Button>
        <Button onClick={save} disabled={saving} data-testid="mapping-save" className="bg-brand-600 hover:bg-brand-700 text-white"><Save className="h-4 w-4 mr-1.5" />Enregistrer</Button>
      </PageHeader>

      <div className="rounded-xl border border-brand-100 bg-brand-50/50 p-4 mb-5 flex items-start gap-2">
        <Link2 className="h-4 w-4 text-brand-600 mt-0.5" />
        <p className="text-sm text-slate-600">Ces comptes sont utilisés par la <strong>Génération automatique des écritures</strong>. Modifiez-les pour adapter le plan comptable à votre organisation. Laisser vide = valeur par défaut.</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {GROUPS.map((g) => (
          <div key={g.title} className="rounded-xl border bg-white p-4">
            <p className="text-[11px] font-mono uppercase tracking-widest text-brand-700 mb-3">{g.title}</p>
            <div className="space-y-3">
              {g.keys.map((k) => (
                <div key={k} className="flex items-center gap-3">
                  <Label className="text-sm text-slate-600 flex-1">{labels[k] || k}</Label>
                  <Input
                    value={form[k] ?? ""}
                    onChange={(e) => setForm({ ...form, [k]: e.target.value })}
                    placeholder={defaults[k]}
                    className="h-9 w-40 font-mono text-sm"
                    data-testid={`mapping-${k}`}
                  />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
